// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__nE-Sg","colBig":"styles_colBig__33qw8","colSmall":"styles_colSmall__38cNS"};